module.exports = __webpack_public_path__ + "img/icon-paperless.cae9746b.svg";